// @ts-nocheck
export const LOADER_COMPONENTS = {
	CREATE_ACCESS: 'CREATE_ACCESS',
};

export const TABLE_ID = 105;
export const COMPLETE_ORDER_STATUSES = [
	'dataready',
	'orderready',
	'inprogress',
	'complete',
	'complete-final',
	'inventory',
];

export const DISABLED_STATUSES = ['pending', 'processing', 'complete-final'];

export const STATUS_INTERVAL_TIMEOUT = 3000;

// @ts-nocheck
export const STORE_PREFIX = 'items';

export const MENU_ITEMS_NAMES = {
	CUSTOMIZE_VIEW: 'Customize View',
	RESET_VIEW: 'Reset View',
	UPLOAD_DATA: 'Upload Data',
	DELETE: 'Delete',
};

export const MENU_ITEMS_VALUES = {
	CUSTOMIZE_VIEW: 'CUSTOMIZE_VIEW',
	RESET_VIEW: 'RESET_VIEW',
	UPLOAD_DATA: 'UPLOAD_DATA',
	DELETE: 'DELETE',
};

export const MENU_ITEMS = [
	{
		displayName: MENU_ITEMS_NAMES.RESET_VIEW,
		value: MENU_ITEMS_VALUES.RESET_VIEW,
	},
	{
		displayName: MENU_ITEMS_NAMES.UPLOAD_DATA,
		value: MENU_ITEMS_VALUES.UPLOAD_DATA,
	},
	{
		displayName: MENU_ITEMS_NAMES.DELETE,
		value: MENU_ITEMS_VALUES.DELETE,
	},
];
